export default {
  'subscriptionList.title': 'Subscription List',
  'subscriptionList.form.shopifyId': 'Shopify Store ID',
  'subscriptionList.form.shopifyId.placeholder': 'Shopify Store ID',
  'subscriptionList.form.merchant': 'Merchant',
  'subscriptionList.form.merchant.placeholder': 'Please select merchant',
  'subscriptionList.form.status': 'Subscription Status',
  'subscriptionList.form.status.placeholder': 'Please select status',
  'subscriptionList.form.customerEmail': 'Customer Email',
  'subscriptionList.form.customerEmail.placeholder': 'Customer Email (fuzzy)',
  'subscriptionList.form.originalOrderId': 'Original Order ID (first)',
  'subscriptionList.form.originalOrderId.placeholder':
    'Original Order ID (first)',
  'subscriptionList.form.subscriptionOrderId': 'Subscription Order ID',
  'subscriptionList.form.subscriptionOrderId.placeholder':
    'Subscription Order ID',
  'subscriptionList.form.dateRange': 'Date Range',
  'subscriptionList.form.startDate': 'Start Date',
  'subscriptionList.form.endDate': 'End Date',
  'subscriptionList.form.search': 'Search',
  'subscriptionList.form.reset': 'Reset',
  'subscriptionList.columns.index': '#',
  'subscriptionList.columns.shopifyId': 'Shopify Store ID',
  'subscriptionList.columns.merchant': 'Merchant',
  'subscriptionList.columns.customerEmail': 'Customer Email',
  'subscriptionList.columns.status': 'Status',
  'subscriptionList.columns.originalOrderId': 'Original Order ID',
  'subscriptionList.columns.subscriptionOrderId': 'Subscription Order ID',
  'subscriptionList.columns.createdAt': 'Created At',
  'subscriptionList.columns.updatedAt': 'Updated At',
  'subscriptionList.columns.operations': 'Actions',
  'subscriptionList.columns.operations.pause': 'Pause',
  'subscriptionList.columns.operations.pauseConfirm':
    'Are you sure you want to pause this subscription?',
  'subscriptionList.columns.operations.pauseSuccess': 'Paused successfully',
  'subscriptionList.columns.operations.pauseError': 'Failed to pause',
  'subscriptionList.columns.operations.resume': 'Resume',
  'subscriptionList.columns.operations.resumeConfirm':
    'Are you sure you want to resume this subscription to active?',
  'subscriptionList.columns.operations.resumeSuccess': 'Resumed successfully',
  'subscriptionList.columns.operations.resumeError': 'Failed to resume',
  'subscriptionList.columns.operations.cancel': 'Cancel',
  'subscriptionList.columns.operations.cancelConfirm':
    'Are you sure you want to cancel this subscription?',
  'subscriptionList.columns.operations.cancelSuccess': 'Cancelled successfully',
  'subscriptionList.columns.operations.cancelError': 'Failed to cancel',
  'subscriptionList.columns.operations.unsubscribe': 'Unsubscribe',
  'subscriptionList.columns.operations.unsubscribeConfirm':
    'Are you sure you want to unsubscribe?',
  'subscriptionList.columns.operations.unsubscribeSuccess':
    'Unsubscribed successfully',
  'subscriptionList.columns.operations.unsubscribeError':
    'Failed to unsubscribe',
  'subscriptionList.operation.batchActions': 'Batch Actions',
  'subscriptionList.operation.batchCancel': 'Batch Cancel',
  'subscriptionList.operation.batchPause': 'Batch Pause',
  'subscriptionList.operation.batchActive': 'Batch Activate',
  'subscriptionList.operation.batchCancelConfirm':
    'Are you sure you want to cancel the selected active subscriptions?',
  'subscriptionList.operation.batchPauseConfirm':
    'Are you sure you want to pause the selected active subscriptions?',
  'subscriptionList.operation.batchActiveConfirm':
    'Are you sure you want to activate the selected paused subscriptions?',
  'subscriptionList.operation.batchCancelSuccess':
    'Batch cancel successful',
  'subscriptionList.operation.batchCancelError': 'Batch cancel failed',
  'subscriptionList.operation.batchPauseSuccess': 'Batch pause successful',
  'subscriptionList.operation.batchPauseError': 'Batch pause failed',
  'subscriptionList.operation.batchActiveSuccess': 'Batch activate successful',
  'subscriptionList.operation.batchActiveError': 'Batch activate failed',
  'subscriptionList.operation.noSelection':
    'Please select subscription records first',
  'subscriptionList.operation.noEligible':
    'No active subscriptions in the selection',
  'subscriptionList.operation.noEligiblePaused':
    'No paused subscriptions in the selection to activate',
  'subscriptionList.operation.export': 'Export',
  'subscriptionList.export.viewProgress': 'View Export Progress',
  'subscriptionList.status.active': 'Active',
  'subscriptionList.status.paused': 'Paused',
  'subscriptionList.status.cancelled': 'Cancelled',
  'subscriptionList.status.failed': 'Failed',
  'subscriptionList.status.expired': 'Expired',
  'subscriptionList.status.renewed': 'Renewed',
};
